import { PublicKey } from "@solana/web3.js";
import { useEffect, useState } from "react";
import { useWallet } from "@solana/wallet-adapter-react";
import { Program, BN, AnchorProvider } from "@coral-xyz/anchor";
import { connection } from "../../constants/constants";
import IDL from "../../constants/token_idl.json";
import useContractInit from "./contractInit";

function useGetTokenQuantity() {
  const { tokenQuantity, slotReleaseDate, getTokenInitializationDetails } =
    useContractInit();
  const wallet = useWallet();
  const [totalGoesOutToken, setTotalGoesOutToken] = useState(0);
  const [totalBuyable, setTotalBuyable] = useState(0);
  const [loadingState, setLoadingState] = useState(true);
  const [currentSlot, setCurrentSlot] = useState(null);

  useEffect(() => {
    const initializeTokenDetails = async () => {
      await getTokenInitializationDetails();
      setLoadingState(false);
    };
    initializeTokenDetails();
  }, []);

  useEffect(() => {
    if (!loadingState && tokenQuantity && slotReleaseDate) {
      getGoesOutToken();
    }
  }, [loadingState, tokenQuantity, slotReleaseDate]);

  const getGoesOutToken = async () => {
    if (wallet) {
      try {
        const provider = new AnchorProvider(connection, wallet, {
          commitment: "confirmed",
        });

        const program = new Program(IDL, provider);

        // console.log("The program instance is: ", program);

        const [monthlyLimitsAccount, monthlyLimitsBump] =
          PublicKey.findProgramAddressSync(
            [Buffer.from("monthly_limits_a")],
            program.programId
          );

        // console.log(
        //   "The monthly limits account value is: ",
        //   monthlyLimitsAccount.toBase58()
        // );

        const remTokens = await program.account.monthlyLimits.fetch(
          monthlyLimitsAccount
        );

        //This value gives the reaminig tokens in the contract
        let rem = remTokens.tokensAvailable;

        const unlocked = remTokens.tokensUnlocked;

        let lastIndex = remTokens.lastCheckedIndex;

        console.log(
          "Total tokens that are available are: ",
          rem.toNumber() / 1e6
        );

        console.log(
          "Total tokens that are unlocked  are: ",
          unlocked.toNumber() / 1e6
        );

        console.log("The last index is: ", lastIndex);

        let totalUnlocked = remTokens.tokensUnlocked;
        let totalGoesOutToken = totalUnlocked.toNumber() / 1e6;
        setTotalGoesOutToken(totalGoesOutToken);
        console.log(
          "\nTotal tokens that has goes-Out (buy+wdl)uptill this point: ",
          totalGoesOutToken
        );

        const timestamps = Object.values(slotReleaseDate);
        const TokenValues = Object.values(tokenQuantity);

        console.log("timestamps", timestamps);
        console.log("TokenValues", TokenValues);

        const findIndexAndSum = () => {
          const currentTime = Math.floor(Date.now() / 1000); // Current time in UNIX timestamp (seconds)
          let idx = null;
          let total = 0;
          console.log("currentTime", currentTime);
          for (let i = 0; i < timestamps.length; i++) {
            console.log("timestamps[i]", timestamps[i]);

            if (currentTime >= timestamps[0]) {
              if (
                (currentTime >= timestamps[i] &&
                  currentTime < timestamps[i + 1]) ||
                i == timestamps.length - 1
              ) {
                idx = i;
                break;
              }
            } else {
              // idx = null;
              break;
            }
          }
          // Sum all values less than the index
          console.log("idx", idx);
          if (idx !== null) {
            for (let i = 0; i <= idx; i++) {
              total += TokenValues[i];
            }
          }

          return { idx, total };
        };

        const { idx, total } = findIndexAndSum();

        const totalBuyableTokens = total - totalGoesOutToken;
        setTotalBuyable(totalBuyableTokens);
        setCurrentSlot(idx);

        console.log(
          "idx=" + idx,
          " total unlocked=" + total,
          " Current total buyAble=",
          total - totalGoesOutToken
        );
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  return {
    getGoesOutToken,
    totalGoesOutToken,
    totalBuyable,
    loadingState,
    currentSlot,
  };
}
export default useGetTokenQuantity;
